import { render, staticRenderFns } from "./offlineavespin.vue?vue&type=template&id=a70a5a52&scoped=true&"
import script from "./offlineavespin.vue?vue&type=script&lang=js&"
export * from "./offlineavespin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a5a52",
  null
  
)

export default component.exports